import React from "react";

export default function BrandLogo({ name, className = "h-7 w-auto" }) {
  const normalized = (name || "").toUpperCase().trim();

  switch (normalized) {
    case "GOOGLE":
      return (
        <svg viewBox="0 0 24 24" className={className} aria-label="Google">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
        </svg>
      );

    case "APPLE":
      return (
        <svg viewBox="0 0 170 170" className={`${className} fill-foreground`} aria-label="Apple">
          <path d="M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.19-2.12-9.97-3.17-14.34-3.17-4.58 0-9.49 1.05-14.75 3.17-5.26 2.13-9.5 3.24-12.74 3.35-4.94.13-9.8-1.94-14.59-6.22-3.17-2.76-7.06-7.39-11.67-13.88-6.19-8.71-11.19-18.9-15.01-30.56-3.82-11.66-5.73-22.9-5.73-33.72 0-13.43 3.35-24.78 10.05-34.05 6.7-9.27 15.17-13.97 25.41-14.1 4.71 0 10.06 1.27 16.05 3.82 5.99 2.55 10.12 3.89 12.39 4.01 1.77.13 5.93-1.27 12.49-4.2 6.56-2.93 12.19-4.33 16.89-4.2 12.59.51 22.37 5.09 29.35 13.74-11.05 6.7-16.44 16.05-16.19 28.05.25 9.53 3.94 17.51 11.07 23.94 7.13 6.43 15.64 10.05 25.53 10.86-2.16 6.34-4.83 12.59-8.01 18.75zM119.22 31.09c0-7.38 2.66-14.42 7.98-21.12 5.32-6.7 11.96-10.47 19.92-11.31.25 1.02.38 1.91.38 2.67 0 7.37-2.73 14.54-8.19 21.51-5.46 6.97-12.22 10.87-20.28 11.71-.13-.9-.19-1.72-.19-2.46z"/>
        </svg>
      );

    case "MICROSOFT":
      return (
        <svg viewBox="0 0 23 23" className={className} aria-label="Microsoft">
          <path fill="#f35325" d="M1 1h10v10H1z"/>
          <path fill="#81bc06" d="M12 1h10v10H12z"/>
          <path fill="#05a6f0" d="M1 12h10v10H1z"/>
          <path fill="#ffba08" d="M12 12h10v10H12z"/>
        </svg>
      );

    case "NETFLIX":
      return (
        <svg viewBox="0 0 111 30" className={`${className} fill-[#E50914]`} aria-label="Netflix">
          <path d="M105.06 14.28L111 30h-5.64l-3.36-9.12-3.42 9.12h-5.52l5.94-15.66L93.36 0h5.64l3.18 8.88L105.36 0h5.58l-5.88 14.28zM80.46 30V0h5.4v30h-5.4zM66.3 30V0h13.2v4.8H71.7v7.8h7.02v4.8H71.7v12.6h-5.4zM53.16 30V0h12.18v4.8H58.56v7.8h6.12v4.8h-6.12v7.8h6.78V30H53.16zM34.8 30V0h13.2v4.8H40.2v7.8h7.02v4.8H40.2V30H34.8zM24.12 30V10.02L16.2 30h-4.38L3.9 10.02V30H0V0h5.52l7.74 19.38L21 0h5.52v30h-2.4z"/>
        </svg>
      );

    case "AMAZON":
      return (
        <svg viewBox="0 0 100 30" className={`${className} fill-foreground`} aria-label="Amazon">
          <path d="M60.7 20.3c-7.3 5.4-17.9 8.2-27.1 8.2-12.7 0-24.1-4.7-32.7-12.5-.7-.6-.1-1.5.7-1 8.6 5.1 19.3 8.2 30.3 8.2 8.3 0 17.5-2.2 25.8-6.8 1.2-.7 2.3.9 1.1 1.7zm3.4-3.1c-.6-.7-3.8-.4-5.2-.2-.4.1-.5-.3-.1-.5 2.3-1.6 6-1.1 6.6-.4.6.8.2 4.6-2 6.4-.4.3-.7.1-.5-.3.6-1.3 1.8-4.3 1.2-5z"/>
          <path d="M47.7 13.9c0-1.7-.1-3.1-.7-4.4-1.2-2.4-3.5-3.6-6.4-3.6-3.8 0-6.7 2.1-7.8 5.7-.2.7.3 1.1.9 1.2l3.4.4c.5.1.9-.3 1-.8.5-1.7 1.8-2.6 3.4-2.6 1.4 0 2.4.6 2.8 1.6.3.7.3 1.7.3 2.6v.7c-2.3 0-5.1.2-7.4.8-3.4.8-5.7 2.8-5.7 6 0 3.6 2.6 5.7 6.1 5.7 2.7 0 4.8-1.2 6.1-3.1h.2v2.5c0 .6.4 1 1 1h4.1c.6 0 1-.4 1-1V13.9zm-6.2 7.1c-.8 1.4-2.1 2.2-3.7 2.2-1.6 0-2.6-.9-2.6-2.2 0-1.6 1.3-2.5 3.7-2.7 1.7-.1 3.5-.2 4.8-.2v1.1c0 .7-.4 1.3-2.2 1.8z"/>
        </svg>
      );

    case "ZOHO":
      return (
        <span className="font-mono font-extrabold text-lg tracking-[0.2em] text-red-600 select-none">
          ZOHO
        </span>
      );

    case "STRIPE":
      return (
        <svg viewBox="0 0 60 25" className={`${className} fill-[#635BFF]`} aria-label="Stripe">
          <path d="M59.64 14.28c0-4.52-2.16-7.3-6.28-7.3-4.16 0-6.68 3.12-6.68 7.24 0 4.88 2.92 7.16 7.08 7.16 2.04 0 3.76-.44 4.96-1.08v-3.24c-1.2.56-2.64.92-4.24.92-1.76 0-3.32-.6-3.52-2.48h8.64c.04-.36.04-.84.04-1.22zm-8.68-1.84c.08-1.6 1.28-2.6 2.48-2.6 1.16 0 2.24.92 2.24 2.60h-4.72zM38.8 21.08h4.28V7.32H38.8v13.76zm-1.88-10.4c0-1.12.92-1.92 2.12-1.92s2.12.8 2.12 1.92c0 1.12-.92 1.92-2.12 1.92s-2.12-.8-2.12-1.92zm-8.68 10.4h4.28v-9.56c.84-.96 2.04-1.28 3.16-1.28.4 0 .76.04 1.04.12V6.6c-.36-.08-.8-.12-1.24-.12-1.88 0-3.48.96-4.32 2.48V7.32h-2.92v13.76zm-8.96-14.8c-2.48 0-4.64.92-5.96 2.2l1.88 2.24c.96-.92 2.48-1.56 4.16-1.56 1.84 0 2.92.8 2.92 1.92 0 .96-.64 1.56-2.48 2.08-3.08.84-5.32 1.8-5.32 4.84 0 2.8 2.24 4.8 5.6 4.8 2.08 0 3.84-.72 4.96-1.84l.08 1.48h3.84V13.8c0-4.52-3.16-7.52-9.68-7.52zm.48 11.96c-1.32 0-2.2-.6-2.2-1.52 0-.96.76-1.4 2.28-1.84 1.96-.56 2.76-1.04 2.76-2.12v2.76c-.76 1.68-2.32 2.72-2.84 2.72zM.64 21.08h4.28V11.2c0-1.52 1.16-2.48 2.68-2.48.44 0 .88.08 1.24.2V5.44c-.44-.12-.96-.2-1.48-.2-2.08 0-3.72.96-4.48 2.48V.4H.64v20.68z"/>
        </svg>
      );

    case "META":
      return (
        <svg viewBox="0 0 100 22" className={`${className} fill-[#0668E1]`} aria-label="Meta">
          <path d="M26.12 0c-4.47 0-8.23 2.41-10.74 5.9C12.87 2.41 9.11 0 4.64 0 1.96 0 0 1.99 0 4.65v12.7c0 2.66 1.96 4.65 4.64 4.65 4.47 0 8.23-2.41 10.74-5.9 2.51 3.49 6.27 5.9 10.74 5.9 2.68 0 4.64-1.99 4.64-4.65V4.65C30.76 1.99 28.8 0 26.12 0zM12 11c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6zm18 0c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z"/>
        </svg>
      );

    case "VERCEL":
      return (
        <svg viewBox="0 0 76 65" className={`${className} fill-foreground`} aria-label="Vercel">
          <path d="M37.5274 0L75.0548 65H0L37.5274 0Z"/>
        </svg>
      );

    case "GITHUB":
      return (
        <svg viewBox="0 0 98 96" className={`${className} fill-foreground`} aria-label="GitHub">
          <path fillRule="evenodd" clipRule="evenodd" d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0112.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"/>
        </svg>
      );

    default:
      return (
        <span className="font-heading font-bold text-xs sm:text-sm tracking-[0.15em] text-foreground select-none text-center truncate px-1 uppercase">
          {name}
        </span>
      );
  }
}
